const mEditionAcademyUsersModalCreate = {
  mEditionAcademyUsersModalCreate: {
    alerts: {
      createAcademiaUsuario: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        rolExistenteDeshabilitado: 'El Rol que desea crear ya existe pero se encuentra deshabilitado.',
        rolExistenteHabilitado: 'El Rol que desea crear ya existe y esta habilitado.',
        rolInmediato: 'Se agrego el Rol nuevo de forma inmediata, ya que el usuario ya pertenecía a la Academia.',
        success: 'La registración de nuevo usuario fue procesada exitosamente. El nuevo usuario recibirá un email de notificación para que acepte las politicas de privacidad.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CREAR',

    inputs: {
      actor: {
        label: 'Rol de Nuevo Usuario'
      },

      email: {
        label: 'Email de Nuevo Usuario',
        placeholder: 'usuario@email.com'
      }
    },

    title: 'Crear Usuario',

    validation: {
      actor: {
        required: 'Tipo de usuario es requerido.'
      },

      email: {
        email: 'El email ingresado no es una cuenta válida.',
        required: 'Email de nuevo usuario es requerido.'
      }
    }
  }
}

export default mEditionAcademyUsersModalCreate
